import alertApi from '../api/alertApi';

export default {
    namespaced: true,
    state: {
        alertTotals : null
    },
    getters: {
        totalCriticals(state) {
            if(state.alertTotals) {
                return state.alertTotals.TotalCriticals;
            }

            return 0;
        },
        totalWarnings(state) {
            if(state.alertTotals) {
                return state.alertTotals.TotalWarnings;
            }

            return 0;
        },
        totalNotices(state) {
            if(state.alertTotals) {
                return state.alertTotals.TotalNotices;
            }

            return 0;
        }
    },
    mutations: {
        updateTotals(state, value) {
            state.alertTotals = value;
        }
    },
    actions: {
        async getTotals({ commit }) {
            let totals = await alertApi.getAlertTotals();
            commit('updateTotals', totals);
        }
    }
}